module.exports = __webpack_public_path__ + "img/banner_ops.bbdaa2b3.jpg";